
namespace TabAurous.Master {

    @Serenity.Decorators.registerClass()
    export class TargetDistributionDialog extends Serenity.EntityDialog<TargetDistributionRow, any> {
        protected getFormKey() { return TargetDistributionForm.formKey; }
        protected getIdProperty() { return TargetDistributionRow.idProperty; }
        protected getLocalTextPrefix() { return TargetDistributionRow.localTextPrefix; }
        protected getNameProperty() { return TargetDistributionRow.nameProperty; }
        protected getService() { return TargetDistributionService.baseUrl; }
        protected getDeletePermission() { return TargetDistributionRow.deletePermission; }
        protected getInsertPermission() { return TargetDistributionRow.insertPermission; }
        protected getUpdatePermission() { return TargetDistributionRow.updatePermission; }

        protected form = new TargetDistributionForm(this.idPrefix);

        constructor() {
            super();
            //set text right align
            q.setTextRightAlign(this.form.January);
            q.setTextRightAlign(this.form.February);
            q.setTextRightAlign(this.form.March);
            q.setTextRightAlign(this.form.April);
            q.setTextRightAlign(this.form.May);
            q.setTextRightAlign(this.form.June);
            q.setTextRightAlign(this.form.July);
            q.setTextRightAlign(this.form.August);
            q.setTextRightAlign(this.form.September);
            q.setTextRightAlign(this.form.October);
            q.setTextRightAlign(this.form.November);
            q.setTextRightAlign(this.form.December);

            this.form.January.changeSelect2(e => {
                if (this.checkValue(this.form.January.value,false)) {
                    alert('Invalid value(Total should not exceed 100)');
                    this.form.January.value = 0;
                }
            });
            this.form.February.changeSelect2(e => {
                if (this.checkValue(this.form.February.value,false)) {
                    alert('Invalid value(Total should not exceed 100');
                    this.form.February.value = 0;
                }
            });
            this.form.March.changeSelect2(e => {
                if (this.checkValue(this.form.March.value,false)) {
                    alert('Invalid value(Total should not exceed 100)');
                    this.form.March.value = 0;
                }
            });
            this.form.April.changeSelect2(e => {
                if (this.checkValue(this.form.April.value,false)) {
                    alert('Invalid value(Total should not exceed 100)');
                    this.form.April.value = 0;
                }
            });
            this.form.May.changeSelect2(e => {
                if (this.checkValue(this.form.May.value,false)) {
                    alert('Invalid value(Total should not exceed 100)');
                    this.form.May.value = 0;
                }
            });
            this.form.June.changeSelect2(e => {
                if (this.checkValue(this.form.June.value,false)) {
                    alert('Invalid value(Total should not exceed 100)');
                    this.form.June.value = 0;
                }
            });
            this.form.July.changeSelect2(e => {
                if (this.checkValue(this.form.July.value,false)) {
                    alert('Invalid value(Total should not exceed 100)');
                    this.form.July.value = 0;
                }
            });
            this.form.August.changeSelect2(e => {
                if (this.checkValue(this.form.August.value,false)) {
                    alert('Invalid value(Total should not exceed 100)');
                    this.form.August.value = 0;
                }
            });
            this.form.September.changeSelect2(e => {
                if (this.checkValue(this.form.September.value,false)) {
                    alert('Invalid value(Total should not exceed 100)');
                    this.form.September.value = 0;
                }
            });
            this.form.October.changeSelect2(e => {
                if (this.checkValue(this.form.October.value,false)) {
                    alert('Invalid value(Total should not exceed 100)');
                    this.form.October.value = 0;
                }
            });
            this.form.November.changeSelect2(e => {
                if (this.checkValue(this.form.November.value,false)) {
                    alert('Invalid value(Total should not exceed 100)');
                    this.form.November.value = 0;
                }
            });
            this.form.December.changeSelect2(e => {
                if (this.checkValue(this.form.December.value,false)) {
                    alert('Invalid value(Total should not exceed 100)');
                    this.form.December.value = 0;
                }
            });
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.isNew) {
                var percent = 100 / 12;
                this.form.January.value = percent;
                this.form.February.value = percent;
                this.form.March.value = percent;
                this.form.April.value = percent;
                this.form.May.value = percent;
                this.form.June.value = percent;
                this.form.July.value = percent;
                this.form.August.value = percent;
                this.form.September.value = percent;
                this.form.October.value = percent;
                this.form.November.value = percent;
                this.form.December.value = percent;
            }

        }
        protected validateBeforeSave() {
            return this.checkValue(0,true);
             
        }
        private checkValue(value: number, beforesave: boolean) {
            var sum = this.form.January.value +
            this.form.February.value +
            this.form.March.value +
            this.form.April.value +
            this.form.May.value +
            this.form.June.value +
            this.form.July.value +
            this.form.August.value +
            this.form.September.value +
            this.form.October.value +
            this.form.November.value +
                this.form.December.value;
            if (sum > 100) {
                return true;
            }
            if (sum != 100 && beforesave==true) {
                return true;
            }
            return false;
        }
    }
}